import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Typography, Button, Alert,
  useMediaQuery, useTheme
} from '@mui/material';
import { FileDownload } from '@mui/icons-material';

export default function DeleteEmployeeDialog({
  open, onClose,
  employee, exported,
  onExport, onConfirmDelete
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog open={open} onClose={onClose} fullScreen={isMobile}>
      <DialogTitle>Delete Employee</DialogTitle>
      <DialogContent>
        {employee && (
          <>
            <Typography gutterBottom>
              You are about to permanently delete <strong>{employee.first_name} {employee.last_name}</strong> and all their time entries.
            </Typography>
            <Alert severity="warning" sx={{ mt: 2, mb: 2 }}>
              <strong>Required:</strong> You must export the employee's data before deletion.
              This action cannot be undone.
            </Alert>
            {!exported ? (
              <Button
                variant="outlined"
                startIcon={<FileDownload />}
                onClick={onExport}
                fullWidth
              >
                Export Employee Data
              </Button>
            ) : (
              <Alert severity="success">
                Data exported. You may now proceed with deletion.
              </Alert>
            )}
          </>
        )}
      </DialogContent>
      <DialogActions sx={{ p: isMobile ? 2 : 1 }}>
        <Button onClick={onClose} size={isMobile ? 'large' : 'medium'}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={onConfirmDelete}
          disabled={!exported}
          size={isMobile ? 'large' : 'medium'}
        >
          Delete Permanently
        </Button>
      </DialogActions>
    </Dialog>
  );
}
